<template>
  <md-layout md-column>
    <span class="md-title">INSTALAÇÕES</span>
    <span class="md-caption">Siga o passo a passo abaixo com atenção. </span>
    <md-stepper
      md-vertical
      md-elevation="0"
      @completed="finishArea()"
    >
      <md-step
        :md-continue="certificationProcess.status>0"
        :md-active="certificationProcess.status <= 0"
        md-label="Carregamento da Planta do BLH"
        md-button-back="Voltar"
        md-button-continue="Próximo: INSTALAÇÕES"
      >
        <md-layout md-column>
          <p>Selecione a planta baixa, fundo branco e linhas pretas.</p>
          <md-button
            class="md-accent md-raised"
            @click="openBlueprintDialog()"
          >DEFINIR PLANTA BLH</md-button>
        </md-layout>
      </md-step>
      <md-step
        :md-continue="certificationProcess.status> 1"
        :md-active="certificationProcess.status == 1"
        md-label="Definição das Instalações"
        md-button-back="Voltar"
        md-button-continue="Próximo: EQUIPAMENTOS"
      >
        <md-layout md-column>
          <p>Descreva as instalações do banco de leite humano</p>
          <md-button
            class="md-accent md-raised"
            @click="openAreas()"
          >INSTALAÇÕES DO BLH</md-button>
        </md-layout>
      </md-step>
      <md-step
        :md-continue="certificationProcess.status > 2"
        :md-active="certificationProcess.status >= 2"
        md-label="Listagem de Equipamentos"
        md-button-back="Voltar"
        md-button-continue="Próximo: Fotos"
      >
        <md-layout md-column>
          <md-button
            class="md-accent md-raised"
            @click="openStructure()"
          >EQUIPAMENTOS DO BLH</md-button>
        </md-layout>
      </md-step>
      <!-- <md-step
        :md-continue="certificationProcess.status >= 3 && canContinue"
        :md-active="certificationProcess.status >= 3"
        md-label="Enviar Estrutura"
        md-button-back="Voltar"
        md-button-continue="Próximo: FOTOS"
      >
        <md-layout md-column>
          <md-layout
            md-column
            v-if="isSyncingArea"
          >
            <div v-if="!syncSuccessfull">
              <span>Enviando Planta</span>
              <md-progress></md-progress>
            </div>
            <div v-else>
              <div v-if="hasError !== ''">
                {{hasError}}
              </div>
              <div v-else>
                <span class="md-title">ENVIADO COM SUCESSO!</span>
                <span class="md-caption">Você já pode prosseguir para a captura das fotos dos equipamentos e instalações</span>
              </div>
            </div>
          </md-layout>
          <md-layout
            md-column
            v-else
          >
            <span class="md-title">ENVIAR ESTRUTRA DO BLH</span>
            <span class="md-caption">*Esta é a uma etapa opcional do processo, você precisa estar conectado à internet até que o envio esteja concluído.</span>
            <md-button
              class="md-accent md-raised"
              @click="syncData()"
            >ENVIAR ESTRUTURAS</md-button>
          </md-layout>
        </md-layout>
      </md-step> -->
    </md-stepper>
    <blueprint-dialog
      ref="startdialog"
      title="Planta do BLH"
      :imageId="certificationProcess.blueprint"
      :blueprintUrl="certificationProcess.blueprintUrl"
      v-on:select="blueprintSelected"
    ></blueprint-dialog>
    <!-- <blueprint-dialog ref="alvaradialog" title="Alvará de funcionamento" :imageId="certificationProcess.alvara" v-on:select="alvaraSelected"></blueprint-dialog> -->
    <md-snackbar
      :md-position="'bottom center'"
      ref="snackbar_sync"
      :md-duration="Infinity"
    >
      <span v-if="isSyncingArea && !syncSuccessfull">Salvando...</span>
      <span v-if="syncSuccessfull">
        <span v-if="hasError !== ''">
          {{hasError}}
        </span>
        <span v-else>
          ENVIADO COM SUCESSO!
        </span>
        <md-button
          class="md-accent"
          md-theme="light-blue"
          @click="$refs.snackbar_sync.close()"
        >Fechar</md-button>
      </span>
    </md-snackbar>
  </md-layout>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import BlueprintDialog from '@/components/BlueprintDialog'
// import is from 'is_js'
export default {
  name: 'area-definition',
  components: {
    BlueprintDialog
  },
  data: () => ({
    isSyncingArea: false,
    syncSuccessfull: false,
    hasError: ''
  }),
  computed: {
    ...mapState({
      uid: state => state.uid,
      blh: state => state.blh,
      certificationProcess: state => state.certificationProcess
    })
  },
  methods: {
    ...mapActions(['SET_PROCESS', 'ADD_IMAGE', 'SET_IMAGE', 'GOTO_STEP', 'UPLOAD_FILE', 'FETCH_IMAGE']),
    openBlueprintDialog () {
      this.$refs.startdialog.openDialog()
    },
    blueprintSelected (...selectedImageArgs) {
      if (!selectedImageArgs) { return }

      const [imageBlob, imgWidth, imgHeight] = selectedImageArgs

      if (!imageBlob) { return }

      const [bpWidth, bpHeight] = this.setCertBlueprintImgRatio(imgWidth, imgHeight)

      // Chegando se já existe um imagem atribuido para a planta
      if (!this.certificationProcess.blueprint) {
        // Caso ainda não exista imagem atribuida para a planta, criamos e adicionamos o blob
        this.ADD_IMAGE(imageBlob).then(imageId => {
          // Utilizamos o id da Imagem para efetuar o upload quando necessario
          this.$set(this.certificationProcess, 'blueprint', imageId)
          // Já que ainda não existe arquivo pra planta, significa que estamos no primeiro passo, por isso atualizamos o status
          this.$set(this.certificationProcess, 'status', 1)

          if (bpWidth > 0) { this.$set(this.certificationProcess, 'bpWidth', bpWidth) }
          if (bpHeight > 0) { this.$set(this.certificationProcess, 'bpHeight', bpHeight) }

          this.$set(this.certificationProcess, 'deviceWidth', window.innerWidth)
          this.$set(this.certificationProcess, 'deviceHeight', window.innerHeight)
          return this.SET_PROCESS(this.certificationProcess)
        })
      } else {
        this.SET_IMAGE({
          id: this.certificationProcess.blueprint,
          image: imageBlob
        }).then(() => {
          // Atualizamos o tamanho da planta para se adequar ao novo arquivo
          if (bpWidth > 0) { this.$set(this.certificationProcess, 'bpWidth', bpWidth) }
          if (bpHeight > 0) { this.$set(this.certificationProcess, 'bpHeight', bpHeight) }
          // Atualizamos o tamanho do aparelho para se adequar ao novo arquivo
          this.$set(this.certificationProcess, 'deviceWidth', window.innerWidth)
          this.$set(this.certificationProcess, 'deviceHeight', window.innerHeight)
          return this.SET_PROCESS(this.certificationProcess)
        })
      }
    },
    setCertBlueprintImgRatio (width, height) {
      let ratio = Math.min(window.innerWidth / width, (window.innerHeight) / height)
      let bpWidth = Math.round(width * ratio)
      let bpHeight = Math.round(height * ratio)
      return [bpWidth, bpHeight]
    },
    finishArea () {
      this.isSyncingArea = false

      if (this.certificationProcess.status < 4) {
        this.$set(this.certificationProcess, 'status', 4)
        this.SET_PROCESS(this.certificationProcess)
        this.GOTO_STEP(1)
      } else {
        this.GOTO_STEP(1)
      }
    },
    openAreas () {
      this.$router.push('/areas')
    },
    openStructure () {
      this.$router.push('/structures')
    },
    syncData () {
      // this.$refs.snackbar_sync.open()
      // this.isSyncingArea = true
      // if (is.online()) {
      //   this.FETCH_IMAGE(this.certificationProcess.blueprint).then(imgBlob => {
      //     let fileName = `${this.blh.currentYear}_${this.blh.id}_${this.certificationProcess.blueprint}.jpg`
      //
      //     this.UPLOAD_FILE({ image: new File([imgBlob], fileName), name: fileName })
      //       .then((fileUrl) => {
      //         this.syncSuccessfull = true
      //         this.certificationProcess.blueprintUrl = fileUrl
      //
      //         this.SET_PROCESS(this.certificationProcess)
      //       })
      //   }).catch(err => {
      //     this.hasError = err
      //     this.syncSuccessfull = true
      //   })
      // } else {
      //   this.hasError = 'Sem conexão com a internet.'
      //   this.syncSuccessfull = true
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AreaDefinitions.vue?b3424290